<template>
  <div class="plLoading" v-if="isShow">
    <div class="plLoadingContent">
      <div class = "redSolid">
        <div class="plLoadingLogo">
          <img src="/static/imgs/fengyan/logomini.png" width="36" height="36"/>
          案件录入错误信息
        </div>
        <div class="plLoadingCon"  id = 'copy_text' style="height: 200px;overflow: auto">
          {{errorMsg}}
          <!--<font  id = 'copy_text' style="width: 20%;">-->
            <!--{{errorMsg1}}-->
          <!--</font>-->
        </div >
      </div>
      <div align="right" style="margin-top: 5px">
        <el-button class="tag-read" type="primary"  data-clipboard-action="copy" data-clipboard-target="#copy_text"  @click="copy" size="mini">复制信息</el-button>
        <el-button @click="close()" size="mini">关    闭</el-button>
      </div><!-- data-clipboard-text="#test"-->
    </div>
  </div>
</template>
<script type="text/ecmascript-6">

import Clipboard from 'clipboard';

export default {
  data() {
    return {
      errorMsg: '',
      errorMsg1: '{201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间, 201805280007=结委时间不能小于导入时间或者起委时间, 201805280006=结委时间不能小于导入时间或者起委时间, 201805280005=结委时间不能小于导入时间或者起委时间, 201805280004=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间,\n' +
        '201805280009=结委时间不能小于导入时间或者起委时间, 201805280008=结委时间不能小于导入时间或者起委时间, 201805280010=结委时间不能小于导入时间或者起委时间, 201805280003=结委时间不能小于导入时间或者起委时间, 201805280002=结委时间不能小于导入时间或者起委时间, 201805280001=结委时间不能小于导入时间或者起委时间, 201805280012=结委时间不能小于导入时间或者起委时间, 201805280011=结委时间不能小于导入时间或者起委时间}',
      isShow: false
    };
  },
  mounted() {
  },
  methods: {
    copy() {
      const clipboard = new Clipboard('.tag-read');
      clipboard.on('success', () => {
        this.$message({
          type: 'success',
          message: '复制成功'
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message({
          type: 'error',
          message: '复制失败'
        });
        // 不支持复制
        // 释放内存
        clipboard.destroy();
      });
    },
    close() {
      this.isShow = false;
    },
    showErrorInfo(errorMsg) {
      // errorMsg = errorMsg.replace(/,/g, '\r');
      this.errorMsg = errorMsg;
      this.isShow = true;
    }
  },
  components: {
    Clipboard
  }
};
</script>

<style lang="less" scoped>
  @import "../../../assets/style/variable";
  .plLoading{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    background-color: rgba(0, 0, 0, .4);
  }
  .plLoadingContent{
    width: 540px;
    position: absolute;
    margin: 0 auto;
    top: 40%;
    left: 50%;
    margin-top: -110px;
    margin-left: -250px;
    background: #fff;
    padding: 40px;
    .redSolid {
      padding: 20px;
      border: 1px solid #ffffff;
      #copy_text {
        border: 1px solid #999;
      }
    }
  }
  .plLoadingLogo{
    height: 60px;
    padding-top: 30px;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
    color: #333;
    img {
      margin-right: 1rem;
      vertical-align: middle;
    }
  }
  .plLoadingCon{
    position: relative;
    width: 500px;
    /*height: 16px;*/
    margin: 30px 0 30px 0;
    border-radius: 8px;
  }
  .plLoadingShow{
    transition: width .5s;
    height: 16px;
    border-radius: 8px;
    /*background-color: #0062b2;*/
    position: absolute;
  }
  .plLoCir{
    transition: left .5s;
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    background-color: #0062b2;
    box-shadow: 0 0 20px #F6AC19;
  }
  .plLoadingNum{
    font-size: 14px;
    color: #0062b2;
    margin-top: 20px;
    margin-left: 102%;
    &:before {
      content: attr(data-percent);
      display: inline-block;
      position: absolute;
      left: 50%;
      top: -24px;
      font-weight: 600;
      font-size: 1rem;
      color: #333;
    }
  }
  .displayNone{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/page/main/import/copyTemp.vue